// eslint-disable-next-line no-unused-vars
import { useEffect, useReducer } from "react";
import { getStateObjects } from "../../services/UrlHelpers";
import { useLocation } from "react-router-dom";
import { RequireAtLeastOne } from "../../services/TypeUtil";

export interface ISearchState {
  documentStatus: number[];
  documentTypes: string[];
  fiscalYears: string[];
  documentNumber: string;
  companyCodes: string[];
  aliasType: "P" | "R";
  aliases: string[];
  fiscalPeriods: number[];
}

type ISearchStateFromLocationReducer = (
  state: ISearchState,
  changes: RequireAtLeastOne<ISearchState> | unknown
) => ISearchState | undefined | unknown;

export function useSearchStateFromLocation(): unknown | ISearchState | undefined {
  const location = useLocation();

  const [searchState, setSearchState] = useReducer<ISearchStateFromLocationReducer>(
    (previousState, changes) => ({
      ...previousState,
      ...(changes as any)
    }),
    undefined as never
  );

  useEffect(() => {
    const stateObjectsFromLocation = getStateObjects(location);
    if (stateObjectsFromLocation && stateObjectsFromLocation.state) {
      const previousNavigationState = stateObjectsFromLocation.state as unknown as { searchState: ISearchState };
      if ("searchState" in previousNavigationState) {
        setSearchState(previousNavigationState.searchState);
      }
    } else {
      setSearchState({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return searchState;
}
